module.exports = __webpack_public_path__ + "static/img/sv-3.bb73fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/sv-3.jpg
// module id = eMc+
// module chunks = 0